import React from 'react';

const Leaderboard = ({ title, data = [] }) => {
  return (
    <div className="leaderboard-card">
      <h3 className="leaderboard-title">{title}</h3>
      <div className="leaderboard-list">
        {data.map((user, index) => (
          <div key={user.id} className="leaderboard-item">
            <span className="leaderboard-rank">#{index + 1}</span>
            <div className="leaderboard-info">
              <div className="leaderboard-name">{user.name}</div>
              <div className="leaderboard-score">{user.score}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};


export default Leaderboard;
